/*
Language map, converts language id to readable label.
*/

export const languages = {
  // Base languages...
  markup: 'Markup',

  // "Markup" includes:
  html: 'HTML',
  xml: 'XML',
  svg: 'SVG',
  mathml: 'MathML',
  ssml: 'SSML',
  atom: 'Atom',
  rss: 'RSS',

  // Additional base languages:
  javascript: 'JavaScript',
  js: 'JavaScript',
  clike: 'C-like',
  css: 'CSS',

  // Begin Add-on languages...
  scss: 'Sass (Scss)',
  twig: 'Twig',
  java: 'Java',
  json: 'JSON',
  rest: 'reST (reStructuredText)',
  bash: 'Bash',
  shell: 'Bash',
  csv: 'CSV',
  docker: 'Docker',
  dockerfile: 'Docker',
  http: 'HTTP',
  jsx: 'React JSX',
  tsx: 'React TSX',
  md: 'Markdown',
  markdown: 'Markdown',
  yml: 'YAML',
  yaml: 'YAML',
};
